import { RegistrationActionTypes, UpdateLoadingPayload } from './types'

export const UPDATE_LOADING = 'REGISTRATION/UPDATE_LOADING'

export const updateLoading = ({ loading }: UpdateLoadingPayload): RegistrationActionTypes => {
  return { type: UPDATE_LOADING, loading }
}
